import type { HostAdapter } from "../core/types.js";

const demoText = "1. 《建筑设计防火规范》 GB 50016-2014\n2. 《民用建筑设计统一标准》 GB 50352-2019";

export const browserHost: HostAdapter = {
  name: "browser",
  version: "dev",
  async getSelectionText() {
    return demoText;
  },
  async getDocumentText() {
    return demoText;
  },
  supportsSelection() {
    return true;
  }
};
